module.exports = __webpack_public_path__ + "img/previous_arrow.a9014d5f.svg";